/* eslint-disable react/jsx-props-no-spreading */
import { flexRender, HeadersInstance } from '@tanstack/react-table';
import { Group, Tooltip } from '@mantine/core';

// Styles & Assets
import ChevronUp from '@/assets/icons/content/chevron-up.svg';
import Help from '@/assets/icons/content/info.svg';

import classes from './Table.module.css';

const Head = ({ tableInstance }: { tableInstance: HeadersInstance<any> }) => (
  <thead>
    {tableInstance.getHeaderGroups().map((headerGroup) => (
      <tr className={classes.tr} key={headerGroup.id}>
        {headerGroup.headers.map((header) => {
          const { column } = header;
          const { noSize } = column.columnDef.meta || {};

          return (
            <th
              scope="col"
              key={header.id}
              onClick={column.getToggleSortingHandler()}
              style={{ width: `${noSize ? '' : column.getSize()}px` }}
              className={`
                ${classes.tableElement}
              `}
            >
              <span
                className={`
                    ${classes.thContent}
                    ${column.getCanSort() ? classes.sortable : ''}
                    ${column.getIsSorted() === 'desc' ? classes.contentDesc : ''}
                    ${column.getIsSorted() ? classes.contentSorted : ''}
            `}
              >
                {flexRender(column.columnDef.header, header.getContext())}

                {column.getCanSort() && <ChevronUp />}

                {column.columnDef.meta?.columnInfo && (
                  <Tooltip label={column.columnDef.meta.columnInfo}>
                    <Group component="span" pl={5}>
                      <Help className="columnInfo" width={17} height={17} />
                    </Group>
                  </Tooltip>
                )}
              </span>
            </th>
          );
        })}
      </tr>
    ))}
  </thead>
);
export default Head;
